import api from '@/api/base'

export default {
    send(time) {
        return api().put('/kiosk/time', time);
    }
}